import { Grid } from "@mui/material";

import React from "react";

import { useParams } from "react-router-dom"; // Need this to get ID

import VitalSignsGraph from "./vitalSignsGraphs";
import VisitHistory from "./VisitHistory";

import ClinicalDocumentation from "./ClinicalDocumentation";

function MedicalRecords() {

  const { id } = useParams(); // Get patient ID from URL
  
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <VisitHistory />
        </Grid>

        {/* --- NEW SECTION ADDED HERE --- */}
        <Grid item xs={12}>
          <ClinicalDocumentation patientId={id} />
        </Grid>
        {/* ------------------------------- */}

        <Grid item xs={12}>
          <VitalSignsGraph />
        </Grid>
      </Grid>
    </>
  );
}

export default MedicalRecords;
